import React from 'react';
import { PRODUCT_NAME } from './constants';
export function Footer() {
  return <footer className="py-6 px-4 bg-brand-ink text-center text-white/50 text-xs" data-id="element-75" data-mp="3gezcj1s77n03">
      <div className="max-w-3xl mx-auto space-y-3" data-id="element-76" data-mp="3gh3s4gzgmag7">
        <p className="leading-snug max-w-2xl mx-auto font-medium" data-id="element-77" data-mp="32ovzn1f7l5nb">
          © 2026 {PRODUCT_NAME} — All Rights Reserved. The information provided
          on this website is intended for educational purposes only and is
          designed as a professional coaching resource for gymnastics coaches
          and instructors. It is not intended to replace professional coaching
          judgment or the safety standards of your club, federation, or
          governing organization. Always apply your professional expertise and
          prioritize athlete safety during every training session.
        </p>
        <div className="flex justify-center gap-3 font-bold tracking-wide uppercase text-white/60" data-id="element-78" data-mp="29ydrvn3jig3k">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-79" data-mp="2ezuupo5l4cms">
            Terms &amp; Conditions
          </a>
          <span data-id="element-80" data-mp="3lbmvdvr3pehh">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-81" data-mp="3gapc1fucueee">
            Privacy Policy
          </a>
          <span data-id="element-82" data-mp="3v89fujfim3iz">·</span>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-83" data-mp="3v8hrk7zwj2sl">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}